'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'signs-post';
var width = 512;
var height = 512;
var aliases = ["map-signs"];
var unicode = 'f277';
var svgPathData = ['M61.5 320l25.6-32 344.9 0 0 64-344.9 0-25.6-32zM80 96l344.9 0 25.6 32-25.6 32-344.9 0 0-64z', 'M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 160.3 0c4.9 0 9.5 2.2 12.5 6L504 118c4.7 5.8 4.7 14.1 0 20l-51.2 64c-3 3.8-7.6 6-12.5 6l-160.3 0 0 32 160 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-160 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-160.3 0c-4.9 0-9.5-2.2-12.5-6L8 330c-4.7-5.8-4.7-14.1 0-20l51.2-64c3-3.8 7.6-6 12.5-6l160.3 0 0-32-168 0c-17.7 0-32-14.3-32-32l0-88c0-22.1 17.9-40 40-40l160 0 0-24zM80 96l0 64 344.9 0 25.6-32-25.6-32-344.9 0zM432 352l0-64-344.9 0-25.6 32 25.6 32 344.9 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSignsPost = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;